import React, { useState, useCallback } from 'react';
import globalURL from 'helper/url';
import {
  DarkPopup,
  Icon,
  SnackBarHelper,
  DarkSquareBorderButton
} from '@lyearn-team/frontend-components';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';

import {
  PopupContentContainer,
  PopupHeaderContainer,
  PopupHeader,
  CloseIcon,
  submitButton,
  PopupBodyContainer,
  PopupContainer,
  ErrorContainer,
  ErrorMessage,
  ErrorFooter,
  PopupBody,
  CloseIconWrapper,
  LoaderIcon,
  FormContainer
} from './styles';

async function fetchPartnerEnvironment(companyId, userEmail) {
  const url = `${
    globalURL.awsEndpoint
  }/partnerEnvInfo?companyId=${companyId}&email=${encodeURIComponent(userEmail)}`;
  const response = await fetch(url);
  return response;
}

export default function SamlLogin(props) {
  const { showPopup, onPopuoClose, companyInfo, redirect } = props;
  const [userEmail, setUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onChangeEmail = useCallback(
    e => {
      if (e.target.value === '' && errorMessage) {
        setErrorMessage('');
      }
      setUserEmail(e.target.value);
    },
    [errorMessage]
  );

  const onSAMLEmailSubmit = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();
      setIsLoading(true);
      const response = await fetchPartnerEnvironment(companyInfo.pid, userEmail);
      if (response.status === 500) {
        const error = await response.json();
        if (error.code === 'USER_NOT_EXISTS') {
          setErrorMessage('user not found');
        } else {
          SnackBarHelper.showSnackbar({
            label: 'Error while fetching partner environment'
          });
        }
      } else {
        const { partnerEnvironment, redirectionDomain } = await response.json();
        redirect('saml', { partnerEnvironment, redirectionDomain });
      }
      setIsLoading(false);
    },
    [companyInfo.pid, redirect, userEmail]
  );

  return (
    <DarkPopup
      header={null}
      popupClassName={PopupContainer}
      bodyClassName={PopupBody}
      showPopup={showPopup}
      style={{ zIndex: '1001' }}
    >
      <PopupContentContainer>
        <PopupHeaderContainer>
          <PopupHeader>You’re almost there...</PopupHeader>
          <CloseIconWrapper onClick={onPopuoClose}>
            <Icon type="close" className={CloseIcon} />
          </CloseIconWrapper>
        </PopupHeaderContainer>
      </PopupContentContainer>
      <PopupBodyContainer>
        <FormContainer onSubmit={onSAMLEmailSubmit}>
          <DarkBoxInput
            placeholder="Enter your email id"
            type="email"
            value={userEmail}
            required={true}
            onChange={onChangeEmail}
          />
          {errorMessage ? (
            <ErrorContainer>
              <ErrorMessage>User not found</ErrorMessage>
              <ErrorFooter>
                Please <a href="https://www.sprinklr.com/">Login to SprinklrU</a> and Login via
                Sprinklr SSO in order to create an account for you on Lyearn
              </ErrorFooter>
            </ErrorContainer>
          ) : null}
        </FormContainer>
        <DarkSquareBorderButton
          disabled={!userEmail || isLoading}
          className={submitButton({ error: errorMessage })}
          onClick={onSAMLEmailSubmit}
          type="filled"
        >
          submit & continue
          {isLoading ? <ActivityIndicator className={LoaderIcon} /> : <Icon type="arrow-right" />}
        </DarkSquareBorderButton>
      </PopupBodyContainer>
    </DarkPopup>
  );
}
